import { useTranslation } from 'react-i18next';
import { cn } from '@utils/cn';
import { JOB_DAY_STATUSES, jobDayStatusStyle } from '../constants';

export const JobDaysLegend = () => {
  const { t } = useTranslation('app', { keyPrefix: 'pages.job.days.status' });

  return (
    <div className="flex flex-wrap gap-x-3 gap-y-1 border-t border-neutral-200 px-3 py-2">
      {JOB_DAY_STATUSES.map((status) => (
        <span key={status} className="flex items-center gap-1.5 text-xs text-neutral-600">
          <span className={cn('h-3 w-3 rounded-sm border', jobDayStatusStyle[status])} />
          {t(status)}
        </span>
      ))}
    </div>
  );
};
